// @ts-nocheck
import React, { useState } from 'react';
import { revertEmail } from '../api';
import { ShieldIcon } from './Icons';

interface RevertEmailPageProps {
    username: string;
    token: string;
    onClose: () => void;
}

export const RevertEmailPage = ({ username, token, onClose }: RevertEmailPageProps) => {
    const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
    const [message, setMessage] = useState('');

    const handleRevert = async () => {
        setStatus('loading');
        try {
            const res = await revertEmail(username, token);
            setStatus('success');
            setMessage(res.message || 'Email successfully restored.');
        } catch (err: any) {
            setStatus('error');
            setMessage(err.response?.data?.error || 'Failed to revert email. The link may be invalid or expired.');
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center">
            <div className="max-w-md w-full bg-gray-900/40 backdrop-blur-xl border border-white/10 rounded-3xl p-8 shadow-2xl">
                <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <ShieldIcon className="w-8 h-8 text-red-500" />
                </div>
                
                <h2 className="text-2xl font-bold text-white mb-4">Security Revert</h2>
                <p className="text-gray-400 mb-8 leading-relaxed">
                    You've requested to revert the email change for account <span className="text-white font-semibold">@{username}</span>. 
                    This will immediately restore your previous email address.
                </p>

                {status === 'idle' && (
                    <button
                        onClick={handleRevert}
                        className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-4 rounded-2xl transition-all shadow-lg shadow-red-600/20 active:scale-95"
                    >
                        Revert Email Change
                    </button>
                )}

                {status === 'loading' && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-8 h-8 border-4 border-red-500 border-t-transparent rounded-full animate-spin" />
                        <p className="text-gray-400">Processing security revert...</p>
                    </div>
                )}

                {status === 'success' && (
                    <div className="space-y-6">
                        <div className="p-4 bg-green-500/10 border border-green-500/20 rounded-2xl text-green-400 text-sm">
                            {message}
                        </div>
                        <button
                            onClick={onClose}
                            className="w-full bg-white/10 hover:bg-white/20 text-white font-bold py-3 rounded-xl transition-all"
                        >
                            Return to App
                        </button>
                    </div>
                )}

                {status === 'error' && (
                    <div className="space-y-6">
                        <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-2xl text-red-400 text-sm">
                            {message}
                        </div>
                        <button
                            onClick={onClose}
                            className="w-full bg-white/10 hover:bg-white/20 text-white font-bold py-3 rounded-xl transition-all"
                        >
                            Cancel
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
